import { FC } from 'react';
import { Flex, Spacer } from '@chakra-ui/react';
import { StatusBadge } from '@shinetools/invoicing-renderer';

import { formatAmount } from 'common/formatAmount';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import SunshineDropdown from 'components/_core/SunshineDropdown';
import Text from 'components/_core/Text';
import { Invoice } from 'features/Work/pages/Invoices/hooks/queries/useGetInvoice';
import { Quote } from 'features/Work/pages/Quotes/hooks/queries/useGetQuote';

import locales from './locales';
import { CardDetailsHeaderOptions } from './types';

interface CardDetailsHeaderProps {
  canEditStatus: boolean;
  item: Invoice | Quote;
  options: CardDetailsHeaderOptions[];
}

const CardDetailsHeader: FC<CardDetailsHeaderProps> = ({
  canEditStatus,
  item,
  options,
}) => (
  <SunshineCard marginBottom="space-36" paddingX="space-16" paddingY="space-24">
    <Flex alignItems="center" gap="space-16">
      <Heading size="lg" variant="number">
        {formatAmount({
          currency: item.currency,
          forcePlusSign: false,
          value: item.totalAmountAfterTaxes,
        })}
      </Heading>

      <StatusBadge status={item.status} type={item.type} />

      <Spacer />

      {canEditStatus ? (
        <SunshineDropdown>
          <SunshineDropdown.Trigger>
            <Button icon="chevron-down" variant="secondary">
              {locales.updateStatus}
            </Button>
          </SunshineDropdown.Trigger>

          <SunshineDropdown.List>
            {options.map((option) => (
              <SunshineDropdown.Item
                icon={option.icon}
                isDisabled={option.isDisabled}
                key={option.label}
                onClick={option.onClick}
              >
                <Text as="span" variant="primary">
                  {option.label}
                </Text>
                <br />
                <Text as="span" fontWeight="weight-400" variant="light">
                  {option.description}
                </Text>
              </SunshineDropdown.Item>
            ))}
          </SunshineDropdown.List>
        </SunshineDropdown>
      ) : null}
    </Flex>
  </SunshineCard>
);

export default CardDetailsHeader;
